/**
 * TCB R6/R28 Compatibility + package integrity runtime adapter.
 * Evaluates existing package intelligence / configuration gates — no parallel BOM engine.
 */
(function (global) {
  'use strict';

  var CFG = global.TCB_COMPATIBILITY_RUNTIME || null;

  function loadConfig(cb) {
    if (CFG) {
      cb(null, CFG);
      return;
    }
    var node = document.querySelector('[data-tcb-compatibility-runtime-url]');
    var url = node && node.getAttribute('data-tcb-compatibility-runtime-url');
    if (!url || !global.fetch) {
      cb(new Error('compatibility_runtime_config_missing'));
      return;
    }
    global
      .fetch(url)
      .then(function (res) {
        return res.json();
      })
      .then(function (json) {
        CFG = json;
        global.TCB_COMPATIBILITY_RUNTIME = json;
        cb(null, json);
      })
      .catch(function (err) {
        cb(err || new Error('compatibility_runtime_fetch_failed'));
      });
  }

  function evaluatePackage(packageId, context) {
    context = context || {};
    if (!CFG || !CFG.packages) {
      return { ok: false, status: 'review_required', error: 'runtime_not_loaded' };
    }
    var pkg = CFG.packages[packageId] || null;
    if (!pkg) {
      return {
        ok: false,
        status: 'invalid',
        package_id: packageId,
        reasons: ['unknown_package'],
        warnings: [],
        purchase_mode: 'quote_preferred'
      };
    }

    var reasons = [];
    var warnings = [];
    var status = 'valid';

    if ((pkg.sku_count || 0) > (CFG.max_skus || 8)) {
      status = 'invalid';
      reasons.push('sku_cap_exceeded');
    }

    if (pkg.surface_gate === 'blocked') {
      status = 'invalid';
      reasons.push('surface_gate_blocked');
    } else if (pkg.surface_gate === 'review') {
      if (status === 'valid') status = 'review_required';
      warnings.push('surface_gate_review');
    }

    if (pkg.job_status === 'catalog_gap_hold') {
      if (status === 'valid') status = 'review_required';
      warnings.push('catalog_gap_hold');
      reasons.push('wet_signage_or_catalog_gap');
    }

    if (pkg.job_status === 'blocker') {
      status = 'invalid';
      reasons.push('job_completeness_blocker');
    }

    if (context.surface_id && pkg.allowed_surface_ids && pkg.allowed_surface_ids.length) {
      if (pkg.allowed_surface_ids.indexOf(context.surface_id) === -1) {
        status = 'invalid';
        reasons.push('surface_not_allowed_for_package');
      }
    }

    if (context.method && pkg.cleaning_method && context.method !== pkg.cleaning_method) {
      warnings.push('method_mismatch_vs_package_default');
      if (status === 'valid') status = 'review_required';
    }

    var purchaseMode = pkg.purchase_mode || 'quote_preferred';
    if (status !== 'valid' && purchaseMode === 'direct_cart') {
      purchaseMode = 'quote_preferred';
    }

    return {
      ok: status === 'valid',
      status: status,
      package_id: packageId,
      configuration_id: pkg.default_configuration_id || null,
      sku_count: pkg.sku_count || 0,
      max_skus: CFG.max_skus || 8,
      purchase_mode: purchaseMode,
      reasons: reasons,
      warnings: warnings,
      evidence: {
        surface_gate: pkg.surface_gate || null,
        job_status: pkg.job_status || null,
        wet_signage_fulfillment: pkg.wet_signage_fulfillment || null,
        source: 'canonical_package_intelligence'
      },
      engine: 'tcb-compatibility-runtime',
      version: CFG.version
    };
  }

  function evaluateAsync(packageId, context, cb) {
    loadConfig(function (err) {
      if (err) {
        cb({ ok: false, status: 'review_required', error: String(err.message || err) });
        return;
      }
      cb(evaluatePackage(packageId, context));
    });
  }

  global.TCBCompatibilityRuntime = {
    version: 'r28.1.0',
    loadConfig: loadConfig,
    evaluate: evaluatePackage,
    evaluateAsync: evaluateAsync
  };
})(typeof window !== 'undefined' ? window : globalThis);
